export default {
  "title": "Codepresso: Online Coding Test & Technical Assessment for Skill-based Hiring",
  "description": "Hire the right developers with Codepresso’s project-based assessments. Evaluate real coding skills across AI, backend, frontend, and more — and get detailed competency reports for every candidate.",
  "ogTitle": "Codepresso: Online Coding Test & Technical Assessment for Skill-based Hiring",
  "ogDescription": "Hire the right developers with Codepresso’s project-based assessments. Evaluate real coding skills across AI, backend, frontend, and more — and get detailed competency reports for every candidate.",
  "home": {
    "skillCertify": {
      "title": "Project-based Coding Test",
      "meta": {
        "title": "Codepresso - Project-based Coding Test",
        "description": "Assess technical skills with a wide range of role- and language-specific tests."
      }
    },
    "skillMonitor": {
      "title": "Individual Skill Reports",
      "meta": {
        "title": "Codepresso - Individual Skill Reports",
        "description": "Gain comprehensive, actionable insights into each developer’s competencies."
      }
    },
    "skillAdvance": {
      "title": "Customized Upskilling and Reskilling",
      "meta": {
        "title": "Codepresso - Customized Upskilling and Reskilling",
        "description": "Experience hyper-personalized learning paths and content tailored to your workforce."
      }
    },
    "hiring": {
      "title": "Use Cases: Hiring Success Stories",
      "meta": {
        "title": "Codepresso - Use Cases: Hiring Success Stories",
        "description": "Discover how leading companies are transforming developer hiring with our proven solutions."
      }
    }
  },
};